import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { classes, Root } from './utils';
import { getHelperText } from '../../../../constants/staticContent';
import closeIcon from '../../../../assets/accountSetting-assets/x-circle.svg';
import {
  addInvoiceConfigurationFlow,
  editFlow,
} from '../../../../services/flowConfiguration';
import Toast from '../../utils/Toast';

const AddFlow = (props) => {
  const {
    editNewFlow,
    setEditNewFlow,
    getAllFlow,
    filterValue,
    setCurrentFlow,
    currentFlow,
    setDeleteConfigurationFlow,
  } = props;
  const [isBackDropLoader, setIsBackDropLoader] = useState(false);
  const [formData, setFormData] = useState({
    flowName: '',
  });

  const [errors, setErrors] = useState({
    flowName: false,
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (!!currentFlow?.name && !!currentFlow?.id) {
      setFormData({ ...formData, flowName: currentFlow?.name });
    }
  }, [editNewFlow]);
  const closeKeyNameForm = () => {
    setFormData({ flowName: '' });
    setEditNewFlow(false);
    setErrors({});
    setDeleteConfigurationFlow(false);
    setCurrentFlow(null);
  };

  // const validateFlowName = (fname) => {
  //   const nameRegex = INVALID_INPUT_REGEX.NAME_WITH_NUMBER;
  //   return nameRegex.test(fname);
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    // if (name === 'flowName') {
    //   const isValidFname = validateFlowName(value);
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     flowName: name === 'flowName' ? !isValidFname : prevErrors.flowName,
    //   }));
    // }
  };

  const handleSave = async () => {
    if (errors?.flowName !== false) {
      setErrors({ flowName: true });
      return;
    }

    let response = null;
    if (currentFlow?.id) {
      if (currentFlow?.name === formData?.flowName) {
        Toast({ message: 'you have not made any changes', variant: 'warning' });
      } else {
        setIsBackDropLoader(true);
        const payload = { flowName: formData?.flowName };
        response = await editFlow(currentFlow?.id, payload);
        setIsBackDropLoader(false);
      }
    } else if (formData?.flowName) {
      setIsBackDropLoader(true);
      response = await addInvoiceConfigurationFlow(formData);
      setIsBackDropLoader(false);
      if (response?.flow?.id) {
        navigate(`/flow-configuration/editor?flowId=${response?.flow?.id}`);
      }
    } else {
      setErrors({ flowName: true });
      return;
    }

    if (response) {
      setEditNewFlow(false);
      setCurrentFlow('');
      getAllFlow(filterValue);
      setFormData({ flowName: '' });

      if (!currentFlow?.id) {
        Toast({ message: `${response?.message}`, variant: 'success' });
      }
    }
  };
  const handleKeyDown = async (event) => {
    if (event.key === 'Enter') {
      handleSave();
    }
  };
  return (
    <Root>
      <Backdrop className={classes.newFlowBackdrop} open={editNewFlow}>
        {isBackDropLoader && (
          <Backdrop
            className={classes.editFlowLoaderBox}
            open={isBackDropLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Card className={classes.cardComponent}>
          <CardHeader
            className={classes.CardHeader}
            title={
              <Grid container alignItems="center">
                <Grid item xs={10}>
                  <Typography variant="h4">
                    {currentFlow?.id ? 'Edit Flow' : 'New Flow'}
                  </Typography>
                </Grid>
                <Grid item xs={2} align="right">
                  <Avatar
                    onClick={closeKeyNameForm}
                    src={closeIcon}
                    className={classes.closeAction}
                  />
                </Grid>
              </Grid>
            }
          />

          <CardContent className={classes.CardContent}>
            <TextField
              fullWidth
              required
              label="Name"
              id="flowName"
              name="flowName"
              autoComplete="flowName"
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              value={formData.flowName}
              error={errors.flowName}
              helperText={getHelperText(
                'flowName',
                'flowName',
                errors,
                formData,
              )}
              autoFocus
            />
            <Box className={classes.actionButtonBox}>
              <Button
                className={classes.cancelButton}
                onClick={closeKeyNameForm}
              >
                <Typography variant="body1">Cancel</Typography>
              </Button>
              <Button
                variant="contained"
                className={classes.saveButton}
                onClick={handleSave}
              >
                <Typography variant="body1">Save</Typography>
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Backdrop>
    </Root>
  );
};

AddFlow.propTypes = {
  editNewFlow: PropTypes.bool.isRequired,
  setEditNewFlow: PropTypes.func.isRequired,
  getAllFlow: PropTypes.func.isRequired,
  filterValue: PropTypes.shape({}).isRequired,
  currentFlow: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  setCurrentFlow: PropTypes.func.isRequired,
  setDeleteConfigurationFlow: PropTypes.func.isRequired,
};
export default AddFlow;
